import React from "react";
import { Hero } from "../components/home/Hero";
import { ServicesSection } from "../components/home/ServicesSection";
import { AboutSection } from "../components/home/AboutSection";
import { ProcessSection } from "../components/home/ProcessSection";
import { QuoteSection } from "../components/home/QuoteSection";
export function Home() {
  return <>
      <Hero data-id="element-212" data-mp="2x7iraukpmqin" />
      <ServicesSection data-id="element-213" data-mp="1zhxlwgve4x0y" />
      <AboutSection data-id="element-214" data-mp="1ziquzohtnym9" />
      <ProcessSection data-id="element-215" data-mp="1zj8xh2v2v92m" />
      <QuoteSection data-id="element-216" data-mp="1zk1xlkzj70bs" />
    </>;
}